const MUSTACHE_TEMPLATE = "#mustache_calculation_item";
const ITEMS_LIST = ".calculation-notices .dropdown-menu ul";

export default class NoticesView {
  render(status) {
    const target = $(ITEMS_LIST).parent().parent();
    $(ITEMS_LIST).html(this.calculationsHtml(status.pendingRounds));

    if (status.hasPendingRounds) target.removeClass("d-none");
    else target.addClass("d-none");
  }

  calculationsHtml(pendingRounds) {
    let html = "";
    for (let i = 0; i < pendingRounds.length; i++) {
      const process = pendingRounds[i];
      html += Mustache.render($(MUSTACHE_TEMPLATE).html(), {
        title: process.round_type,
        processType: process.process_type_humanized,
        date: process.created_at,
      });
    }
    return html;
  }
}
